/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [response: vp.ApiResponse, QuestionID: (params: vp.FAQRequest) => void, reset: () => void];
type ApiHook = (props: HookProps) => HookTuple;

const usePostFAQUpdateClickCount: ApiHook = ({ api }) => {
  const [shouldUpdateClickCount, setShouldUpdateClickCount] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.FAQRequest>({
    QuestionID: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldUpdateClickCount) return () => {};

    const PostUpdateClickCount = async () => {
      const res = await api.postFAQUpdateClickCount(params, source);
      setResponse(res);
    };

    if (shouldUpdateClickCount) void PostUpdateClickCount();
    setShouldUpdateClickCount(false);
    return () => {
      source.cancel();
    };
  }, [shouldUpdateClickCount]);

  return [
    response,
    (_params: vp.FAQRequest) => {
      setParams(_params);
      setShouldUpdateClickCount(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldUpdateClickCount(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostFAQUpdateClickCount);
